module.exports = __webpack_public_path__ + "img/turkish_eggs.ec9401bb.jpg";